import React from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  HeadingText,
  BodyText,
  v2blue700,
  v2grey50,
} from '@paypalcorp/pp-react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import style from './promoMessage.less';

const PromoMessage = ({
  header,
  headerSize,
  subHeader,
  CTAText,
  CTAUrl,
  imageUrl,
  imagePosition,
  hasImageOffset,
  backgroundColor,
  promoContainerOffset,
  imageProps,
  mobileImagePosition,
  onClick,
  isDarkBackground,
  isTertiaryButton,
}) => {
  const headerComponent = (
    <Col sm={6} xs={12}>
      <div className={`${style.headerContainer} ${style.verticalCenter}`}>
        <HeadingText
          size={headerSize}
          style={{
            color: isDarkBackground ? v2grey50 : v2blue700,
            marginBottom: '10px',
          }}
        >
          {header}
        </HeadingText>
        <BodyText style={{ color: isDarkBackground ? v2grey50 : v2blue700 }}>
          {subHeader}
        </BodyText>
        <Button
          className={style.promoMessageButton}
          style={{
            color: isTertiaryButton && isDarkBackground ? v2grey50 : '',
          }}
          as='a'
          href={CTAUrl}
          role='button'
          onClick={onClick}
          inverse={isDarkBackground}
          tertiary={isTertiaryButton}
        >
          {CTAText}
        </Button>
      </div>
    </Col>
  );
  const imgComponent = (
    <Col
      sm={6}
      xs={12}
      className={
        hasImageOffset
          ? `${style.topOffset} ${style.centerAlign}`
          : style.centerAlign
      }
    >
      <img
        alt='bannerImg'
        src={imageUrl}
        className={style.promoImage}
        height={imageProps && imageProps.height}
        width={imageProps && imageProps.width}
      />
    </Col>
  );
  return (
    <Container
      fluid={true}
      style={{ backgroundColor }}
      className={
        promoContainerOffset
          ? `${style.promoContainerOffset} ${style.parentPromoContainer}`
          : style.parentPromoContainer
      }
    >
      <Container className={style.promoMessageContainer}>
        <MediaQuery maxWidth={480}>
          <Row noGutters={true}>
            {imageProps && imageProps.mobilePosition === 'bottom'
              ? [headerComponent, imgComponent]
              : [imgComponent, headerComponent]}
          </Row>
        </MediaQuery>

        <MediaQuery minWidth={481}>
          <Row noGutters={true}>
            {imagePosition === 'left'
              ? [imgComponent, headerComponent]
              : [headerComponent, imgComponent]}
          </Row>
        </MediaQuery>
      </Container>
    </Container>
  );
};

PromoMessage.propTypes = {
  header: PropTypes.string.isRequired,
  headerSize: PropTypes.string,
  subHeader: PropTypes.string.isRequired,
  CTAText: PropTypes.string.isRequired,
  CTAUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imagePosition: PropTypes.string,
  hasImageOffset: PropTypes.bool,
  backgroundColor: PropTypes.string,
  promoContainerOffset: PropTypes.bool,
  imageProps: PropTypes.object,
  onClick: PropTypes.func,
};

PromoMessage.defaultProps = {
  headerSize: 'lg',
  imagePosition: 'right',
  hasImageOffset: false,
  backgroundColor: '#FFE888',
  promoContainerOffset: false,
  isTertiaryButton: false,
};

export default PromoMessage;
